import React, {useState} from "react";
import {Step1GeneralInfo} from "./pro-group-creation-wizard-steps/Step1GeneralInfo";
import {Step2Providers} from "./pro-group-creation-wizard-steps/Step2Providers";
import {Step3Guests} from "./pro-group-creation-wizard-steps/Step3Guests";
import {Step4Validation} from "./pro-group-creation-wizard-steps/Step4Validation";
import {TabData, Wizard} from "../../../_shared/wizard/Wizard";
import {Provider} from "../../../../models/pro-guest.models";
import {UserItem} from "../../../../models/shared";

interface Props {
    goBack: () => void,
    organizationId: number,
    folderId: number
}

export const ProGroupCreationWizard: React.FC<Props> = ({goBack, organizationId, folderId}) => {
    const [addGroupForm, setAddGroupForm] = useState({name: '', providers: [] as Provider[], guests: [] as UserItem[]});

    const handleNameChange = (newName: string) => {
        setAddGroupForm(prev => ({...prev, name: newName}));
    }

    const changeProviderSelection = (selectedProviders: Provider[]) => {
        setAddGroupForm(prev => ({
            ...prev,
            providers: selectedProviders
        }))
    }

    const changeGuestList = (guests: UserItem[]) => {
        setAddGroupForm(prev => ({
            ...prev,
            guests: guests
        }))
    }

    const step1: TabData = {
        labelKey: 'ProGuest.Groups.Tabs.General.Title',
        key: 'pro-group-creation-general',
        isDisabled: true,
        preserveTab: true,
        childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) => <Step1GeneralInfo
            onNameChange={handleNameChange} onChangeTab={onChangeTab} onClose={goBack}
            index={index} lastIndex={lastIndex}/>
    }

    const step2: TabData = {
        labelKey: 'ProGuest.Groups.Tabs.Providers.Title',
        key: 'pro-group-creation-providers',
        isDisabled: true,
        preserveTab: true,
        childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) => <Step2Providers
            onClose={goBack}
            index={index}
            lastIndex={lastIndex}
            onChangeTab={onChangeTab}
            organizationId={organizationId}
            folderId={folderId}
            onChangeProviderSelection={changeProviderSelection}
            guestsCount={addGroupForm.guests.length}/>
    }

    const step3: TabData = {
        labelKey: 'ProGuest.Groups.Tabs.Guests.Title',
        key: 'pro-group-creation-guest',
        isDisabled: true,
        preserveTab: true,
        childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) => <Step3Guests
            onChangeTab={onChangeTab}
            index={index}
            lastIndex={lastIndex}
            onClose={goBack}
            onChangeGuestList={changeGuestList}
            providersCount={addGroupForm.providers.length}/>
    }

    const step4: TabData = {
        labelKey: 'ProGuest.Groups.Tabs.Validation.Title',
        key: 'pro-group-creation-validation',
        isDisabled: true,
        preserveTab: false,
        childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) => <Step4Validation
            onClose={goBack}
            index={index}
            lastIndex={lastIndex}
            onChangeTab={onChangeTab}
            form={addGroupForm}
            organizationId={organizationId}
            folderId={folderId}/>
    }

    return <Wizard tabs={[step1, step2, step3, step4]}/>
}
